import { render, staticRenderFns } from "./SalesReportFilterLabels.vue?vue&type=template&id=5282abd4&"
import script from "./SalesReportFilterLabels.vue?vue&type=script&lang=ts&"
export * from "./SalesReportFilterLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports